import * as moment from 'moment';
import * as React from 'react';
import { connect } from 'react-redux';
import Toggle from 'react-toggle';
import { ApplicationState } from 'src/store';
import { alertError } from 'src/store/alert/actions';
import { BikeTypes } from 'src/store/bus/types';
import { CardEvent, Station } from 'src/store/events/types';
import { registerParticipant } from 'src/store/participant/actions';
import { RegisterParticipant } from 'src/store/participant/types';
import { User } from 'src/store/user/types';
import './AddParticipant.scss';
import SuggestUser from './SuggestUser';

interface FormValues {
  firstName: string;
  lastName: string;
  phoneNr: string;
  business: User | undefined;
  isChild: boolean;
  isStaff: boolean;
  age: number | '';
  bikeType: BikeTypes;
  stationId?: number;
}

const initialValues: FormValues = {
  firstName: '',
  lastName: '',
  phoneNr: '',
  business: undefined,
  isChild: false,
  isStaff: false,
  age: '',
  bikeType: 0,
  stationId: undefined
};

interface MyState {
  errors: any;
  values: FormValues;
  touched: any;
  isValid: boolean;
  submitted: boolean;
  businessAutocomplete: string;
}

const InputStructure = ({ renderF, className }: any) => (
  <div className={'row' + (className ? ' ' + className : '')}>{renderF}</div>
);

const ErrorMessage = ({ state, name }: any) => (
  <React.Fragment>
    {(state.touched[name] || state.submitted) && state.errors[name] && (
      <div className="error">{state.errors[name]}</div>
    )}
  </React.Fragment>
);

interface Props {
  event: CardEvent;
  loading: boolean;
  user: User;
}

interface PropsFromDispatch {
  registerParticipant: typeof registerParticipant;
  alertError: typeof alertError;
}
type AllProps = Props & PropsFromDispatch;

class AddParticipant extends React.Component<AllProps, MyState> {
  constructor(props: AllProps) {
    super(props);

    this.state = {
      errors: {},
      values: initialValues,
      touched: {},
      isValid: false,
      submitted: false,
      businessAutocomplete: ''
    };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.setError = this.setError.bind(this);
    this.validateField = this.validateField.bind(this);
    this.resetError = this.resetError.bind(this);
    this.validateForm = this.validateForm.bind(this);
    this.mySetState = this.mySetState.bind(this);
  }

  componentDidMount() {
    this.validateForm();
  }

  public render() {
    const { event } = this.props;
    return (
      <div className="addParticipantForm">
        <InputStructure renderF={this.generateInput('firstName', 'text', null, 'Vorname')} />
        <InputStructure renderF={this.generateInput('lastName', 'text', null, 'Nachname')} />
        <InputStructure
          renderF={
            <React.Fragment>
              <input
                type="tel"
                className={this.errorClassName('phoneNr')}
                name="phoneNr"
                placeholder="+43 664 1234123"
                pattern="^[+]{1}[0-9]{1,2}[\s]{1}[0-9]{3,4}[\s]{1}[0-9].*$"
                // required={true}
                onChange={e => {
                  this.handleChange(e, 'phoneNr');
                }}
                onBlur={this.handleBlur.bind(this, 'phoneNr')}
              />
              <ErrorMessage state={this.state} name={'phoneNr'} />
            </React.Fragment>
          }
        />
        <InputStructure
          renderF={
            <React.Fragment>
              <div>
                <span className="big">Erwachsener</span>
                <Toggle
                  icons={false}
                  defaultChecked={false}
                  onChange={() => {
                    this.handleChange(null, 'isChild', !this.state.values.isChild);
                  }}
                />
                <span className="big">Kind</span>
              </div>
              {this.state.values.isChild && (
                <div className="col-lg-6">
                  {this.generateInput(
                    'age',
                    'number',
                    <label style={{ lineHeight: '35px' }} className="sm med" htmlFor="age">
                      Alter(Jahren)
                    </label>,
                    '',
                    '1',
                    '99'
                  )}
                </div>
              )}
            </React.Fragment>
          }
        />
        <InputStructure
          renderF={
            <div>
              <span className="big">Gästekarte</span>
              <Toggle
                icons={false}
                defaultChecked={false}
                onChange={() => {
                  this.handleChange(null, 'isStaff', !this.state.values.isStaff);
                }}
              />
              <span className="big">Mitarbeiterkarte</span>
            </div>
          }
        />
        {this.props.user.role.canReadUser && (
          <InputStructure
            renderF={
              <div className="addPartChooseBusiness">
                <SuggestUser
                  errorClassName={this.errorClassName('business')}
                  placeholder="Betrieb"
                  value={this.state.values.business}
                  type="business"
                  onBlur={this.handleBlur.bind(this, 'business')}
                  onSelected={(user: User) => {
                    this.handleChange(null, 'business', { id: user.id, name: user.name });
                  }}
                />
                <ErrorMessage name="business" state={this.state} />
              </div>
            }
          />
        )}
        {event && (event.bikesAllowed || (event.buses && event.buses.length > 0)) && (
          <InputStructure
            renderF={
              <React.Fragment>
                {event.bikesAllowed && (
                  <div>
                    <span className="big">Bike</span>
                    <Toggle
                      icons={false}
                      defaultChecked={false}
                      onChange={() => {
                        this.setState(prevState => ({
                          ...prevState,
                          values: {
                            ...prevState.values,
                            bikeType: prevState.values.bikeType === 0 ? 1 : 0
                          }
                        }));
                      }}
                    />
                    <span className="big">E-Bike</span>
                  </div>
                )}
                <div className="col-lg-7" style={{ float: 'right' }}>
                  {!!event.buses &&
                    !!event.buses[0] &&
                    event.buses[0].stations &&
                    event.buses[0].stations.length > 0 && (
                      <select
                        className={this.errorClassName('stationId')}
                        onChange={e => {
                          const value = e.target.value;
                          this.handleChange(null, 'stationId', value);
                        }}
                      >
                        <option value={undefined} />
                        {this.renderStations(event.buses[0].stations)}
                      </select>
                    )}
                  <ErrorMessage state={this.state} name={'stationId'} />
                </div>
              </React.Fragment>
            }
          />
        )}
        {/* {event && event.bikesAllowed && (
            <InputStructure
              renderF={
                <React.Fragment>
                  <span className="big">Bike</span>
                  <Toggle
                    icons={false}
                    defaultChecked={false}
                    onChange={() => {
                      this.setState(prevState => ({
                        ...prevState,
                        values: {
                          ...prevState.values,
                          bikeType: prevState.values.bikeType === 0 ? 1 : 0
                        }
                      }));
                    }}
                  />
                  <span className="big">E-Bike</span>
                </React.Fragment>
              }
            />
          )}
          {event && event.buses && event.buses.length > 0 && (
            <InputStructure
              renderF={
                <React.Fragment>
                  {event.buses[0].stations && event.buses[0].stations.length > 0 && (
                    <select
                      className={this.errorClassName('stationId')}
                      onChange={e => {
                        const value = e.target.value;
                        this.handleChange(null, 'stationId', value);
                      }}
                    >
                      <option value={undefined} />
                      {this.renderStations(event.buses[0].stations)}
                    </select>
                  )}
                  <ErrorMessage state={this.state} name={'stationId'} />
                </React.Fragment>
              }
            />
          )} */}
        <InputStructure
          renderF={
            <button
              type="submit"
              style={{ margin: '0 0' }}
              onClick={this.handleSubmit}
              disabled={this.state.submitted && this.props.loading}
            >
              Anmelden
            </button>
          }
        />
      </div>
    );
  }

  renderStations = (st: Station[]) => {
    const stations = [...st];
    stations.sort((a: Station, b: Station) => {
      if (moment(a.time, 'HH:mm').isBefore(moment(b.time, 'HH:mm'))) {
        return -1;
      } else if (moment(a.time, 'HH:mm').isAfter(moment(b.time, 'HH:mm'))) {
        return 1;
      } else {
        return 0;
      }
    });

    return stations.map((station: Station, i: number) => (
      <option key={i} value={station.id}>
        {station.place} - {station.time}
      </option>
    ));
  };

  private handleSubmit(e: any) {
    e.preventDefault();
    this.setState({ submitted: true });
    if (this.validateForm()) {
      const values = this.state.values;
      if (true) {
        const data: RegisterParticipant = {
          age: values.age !== '' ? values.age : -1,
          biketype: this.props.event.bikesAllowed ? BikeTypes[values.bikeType] : undefined,
          eventId: this.props.event.id,
          firstname: values.firstName,
          lastname: values.lastName,
          isChild: values.isChild,
          isStaff: values.isStaff,
          phonenumber: values.phoneNr,
          stationId: values.stationId,
          creatorId:
            this.props.user && this.props.user.role.canReadUser
              ? values.business
                ? values.business.id
                : undefined
              : this.props.user.id
        };
        this.props.registerParticipant(data);
        // this.setState({ values: initialValues });
      } else {
        this.props.alertError(new Error('Formular fehlerhaft'));
      }
    }
  }

  private generateInput(
    name: string,
    type: string,
    label?: any,
    placeholder = '',
    min = '',
    max = ''
  ) {
    return (
      <React.Fragment>
        {label != null && label}
        <input
          id={name}
          min={min}
          max={max}
          type={type}
          className={this.errorClassName(name)}
          placeholder={placeholder}
          onBlur={this.handleBlur.bind(this, name)}
          value={this.state.values[name]}
          onChange={e => {
            this.handleChange(e, name);
          }}
        />
        <ErrorMessage state={this.state} name={name} />
      </React.Fragment>
    );
  }

  private errorClassName = (property: string) => {
    return this.state.errors[property] && (this.state.touched[property] || this.state.submitted)
      ? 'inputError'
      : '';
  };

  private handleBlur(name: string) {
    const touched = { ...this.state.touched };
    touched[name] = true;
    this.setState({ touched });
  }

  private handleChange(e: any, name: string, value?: any) {
    const values = { ...this.state.values };
    if (!value && e) {
      values[name] = e.target.value;
    } else {
      values[name] = value;
    }
    this.setState({ values }, () => {
      this.validateField(name);
    });
  }

  private mySetState(name: string, value: any) {
    const values = { ...this.state.values };
    let val = values[name];
    if (Array.isArray(value)) {
      val = [...val, ...value];
    } else {
      values[name] = value;
    }
    this.setState({ values });
  }

  private setError(name: string, value: string | null) {
    this.setState(prevState => ({
      ...prevState,
      errors: {
        ...prevState.errors,
        [name]: value
      }
    }));
  }

  private resetError(name: string) {
    if (this.state.errors[name] != null) {
      this.setError(name, null);
    }
  }

  private validateField(name: string): boolean | null {
    const value = this.state.values[name];
    let valid = true;
    switch (name) {
      case 'firstName': {
        if (!value || value.length <= 0) {
          this.setError(name, 'Bitte geben Sie einen Vornamen ein');
          valid = false;
        } else if (value.length <= 2) {
          this.setError(name, 'Vorname muss länger als 2 Zeichen sein');
          valid = false;
        } else {
          this.resetError(name);
        }
        break;
      }
      case 'lastName': {
        if (!value || value.length <= 0) {
          this.setError(name, 'Bitte geben Sie einen Nachnamen ein');
          valid = false;
        } else if (value.length <= 2) {
          this.setError(name, 'Nachname muss länger als 2 Zeichen sein');
          valid = false;
        } else {
          this.resetError(name);
        }
        break;
      }
      case 'phoneNr': {
        if (!value || value.length <= 0) {
          this.setError(name, 'Bitte geben Sie eine Telefonnummer ein');
          valid = false;
        } else {
          const reg = new RegExp(/^[+]{1}[0-9]{1,2}[\s]{1}[0-9]{3,4}[\s]{1}[0-9].*$/m);
          if (!reg.test(value)) {
            this.setError(name, 'Bitte geben Sie die Nummer im Format +43 664 1231231 ein');
            valid = false;
          } else {
            this.resetError(name);
          }
        }
        break;
      }
      case 'business': {
        if (this.props.user && this.props.user.role.canReadUser) {
          if (!value) {
            this.setError(name, 'Bitte wählen Sie einen Betrieb aus');
            valid = false;
          } else {
            this.resetError(name);
          }
        }
        break;
      }
      case 'stationId': {
        if (this.props.event.buses && this.props.event.buses.length > 0) {
          if (!value) {
            this.setError(name, 'Bitte wählen Sie eine Station aus');
            valid = false;
          } else {
            this.resetError(name);
          }
        }
        break;
      }
      default:
        return true;
    }
    return valid;
  }

  private validateForm(): boolean {
    let result = true;
    for (const prop in this.state.values) {
      if (this.state.values.hasOwnProperty(prop)) {
        if (!this.validateField(prop)) {
          result = false;
        }
      }
    }
    this.setState({ isValid: result });
    return result;
  }
}

const mapStateToProps = ({ parts, auth }: ApplicationState) => ({
  user: auth.data,
  loading: parts.loading
});

const mapDispatchToProps = (dispatch: any) => ({
  registerParticipant: (partData: RegisterParticipant) => dispatch(registerParticipant(partData)),
  alertError: (err: Error) => dispatch(alertError(err))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AddParticipant);



// WEBPACK FOOTER //
// ./src/pages/Event/EventDetail/AddParticipant/AddParticipant.tsx